// src/components/LoadingOverlay.jsx
import React from "react";
import { CircularProgress } from "@mui/material";
import loadingImage from "../assets/logo.png"; // Replace with your actual image path

const LoadingOverlay = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        flexDirection: "column",
      }}
    >
      <img
        src={loadingImage}
        alt="Loading..."
        style={{
          width: "200px",
          marginBottom: "20px",
        }}
      />
      <CircularProgress
        size={62}
        sx={{
          color: "primary.main", // You can customize the color
        }}
      />
    </div>
  );
};

export default LoadingOverlay;